/**
 * Giriş ekranının zemini: markanın gradyan uçlarından iki yumuşak bulut.
 *
 * Sabit bir görsel yerine CSS: ağ isteği yok, her ekran boyutunda keskin ve tema
 * değiştiğinde zemine uyum sağlıyor. Bulutlar `pointer-events-none` — formun önünde
 * duruyor gibi görünse de hiçbir tıklamayı yakalamaz.
 */
export function LoginBackdrop() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      <div
        className="octo-aurora-a absolute -top-32 -left-24 h-[28rem] w-[28rem] rounded-full opacity-40 blur-3xl sm:opacity-50"
        style={{
          background: 'radial-gradient(circle at 30% 30%, var(--brand-gradient-from), transparent 65%)',
        }}
      />
      <div
        className="octo-aurora-b absolute -right-32 -bottom-40 h-[32rem] w-[32rem] rounded-full opacity-35 blur-3xl sm:opacity-45"
        style={{
          background: 'radial-gradient(circle at 60% 60%, var(--brand-gradient-to), transparent 65%)',
        }}
      />
      {/* İnce ızgara dokusu: boş zemine derinlik verir, okunurluğu bozmayacak kadar soluk. */}
      <div
        className="absolute inset-0 opacity-[0.035]"
        style={{
          backgroundImage:
            'linear-gradient(var(--fg) 1px, transparent 1px), linear-gradient(90deg, var(--fg) 1px, transparent 1px)',
          backgroundSize: '44px 44px',
        }}
      />
    </div>
  );
}
